import React from 'react';
import PropTypes from 'prop-types';
import Card from 'reactstrap/lib/Card';
import { VEHICLE_SELECT_MODE_MAP } from 'site-modules/shared/constants/price-checker';

import './when-dealer-calls.scss';

export function WhenDealerCalls({ onModeChange }) {
  return (
    <Card
      className="when-dealer-calls pt-1 pb-0_5 ps-1 pe-1_5 mt-xl-0_25"
      data-tracking-parent="price-checker-coaching"
    >
      <div className="heading-4 mb-1_5 mb-md-1_5">When you speak with dealers</div>
      <ul className="check-list text-gray-darker list-unstyled m-0">
        <li className="d-flex mb-1">Ask the dealer for their best price</li>
        <li className="d-flex mb-1">Confirm that the vehicle being quoted has the features and options you want</li>
        <li className="d-flex mb-1">
          Get it in writing. Ask the dealer to email you their best price. Most dealers won’t email it unless you ask.
        </li>
        <li className="d-flex mb-1">
          <span>
            Ask for the MSRP and{' '}
            <button
              className="vin-btn border-0 p-0 text-primary-darker"
              onClick={onModeChange}
              data-value={VEHICLE_SELECT_MODE_MAP.VIN}
              data-tracking-id="pc_vin_in_text"
            >
              VIN
            </button>{' '}
            too so you can enter it into this tool and determine if your quote is a good deal.
          </span>
        </li>
      </ul>
    </Card>
  );
}

WhenDealerCalls.propTypes = {
  onModeChange: PropTypes.func.isRequired,
};
